import React from "react";
import { RefineKbar } from "@pankod/refine-kbar";

export const OffLayoutArea: React.FC = () => {
  return <RefineKbar />;
};
